'use client';
import { useEffect } from 'react';
import { event_errors } from './gtm';

function ErrorEvent({ error_message, error_code, error_type }) {
  useEffect(() => {
    event_errors({ error_message, error_code, error_type });
  }, [error_message, error_code, error_type]);

  return <></>;
}

export default ErrorEvent;
